<script>
    export let nextScene;
</script>

<style>
    /* previous version (arrow.png) */
    /* div {
        background: rgba(var(--primary-color-rgb),0.8);
        color: white;
        padding: 0.05rem;
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        z-index: 999;
        border-radius: 10px 0 0 10px;
        cursor:pointer;
    } */

    div {
        background: rgba(var(--primary-color-rgb),0.8);
        color: white;
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        z-index: 999;
        border-radius: 10px 0 0 10px;
        cursor:pointer;
        padding: 20px 10px 20px 20px;
    }

    div:hover {
        border: 3px solid rgba(255,255,255,1);
        border-width: 3px 0 3px 3px;
        background: rgba(var(--primary-color-rgb),1);
    }

    img {
        transform: scaleX(-1);
    }
</style>

<div on:click="{nextScene}">
    <!-- <img src="./images/arrow.png" width="60" height="60" alt="Next Scene"/> -->
    <img src="./images/direction.png" width="35" height="35" alt="Next Scene"/>
</div>